import { HubConnection } from '@microsoft/signalr';
import { useEffect, useRef } from 'react';
import {
  createNotificationHubConnection,
  NotificationReceivedPayload,
  startNotificationHubConnection,
} from '../services/notificationHub';
import { getStoredAccessToken } from '../services/apiClient';

type UseNotificationHubOptions = {
  enabled: boolean;
  onNotification: (payload: NotificationReceivedPayload) => void;
};

export function useNotificationHub({ enabled, onNotification }: UseNotificationHubOptions): void {
  const connectionRef = useRef<HubConnection | null>(null);
  const handlerRef = useRef(onNotification);

  handlerRef.current = onNotification;

  useEffect(() => {
    if (!enabled || !getStoredAccessToken()) {
      return;
    }

    const connection = createNotificationHubConnection((payload) => {
      handlerRef.current(payload);
    });
    connectionRef.current = connection;

    void startNotificationHubConnection(connection).catch(() => {
      // A conexão será retentada pelo automatic reconnect ou no próximo login.
    });

    return () => {
      void connection.stop();
      connectionRef.current = null;
    };
  }, [enabled]);
}
